export const sendEmail = async (to, subject, body) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/send-contact-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: to,
        subject: subject,
        message: body,
      }),
    });

    if (!response.ok) {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Failed to send email (Status: ${response.status})`);
      } else {
        const text = await response.text();
        throw new Error(`Failed to send email: Server returned an unexpected response (Status: ${response.status}): ${text.slice(0, 100)}...`);
      }
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};
